<template>
  <div class="home">
   <v-app><!-- 必须存在 -->
    <v-app-bar
      app
      :color='barColor'
      dark
      :flat='barFlat'
      :hide-on-scroll='barHide'
    >
      <div class="d-flex align-center" to="/">
        <v-img alt="嘉旭福美" class="shrink mt-1 hidden-sm-and-down" contain min-width="100" width="100"/>
        <!-- logo -->
        <v-img alt="Vuetify Logo" class="shrink mr-2" contain src="../assets/images/logo.png"
          transition="scale-transition"
          height="40"
          width="40"
          style='cursor:pointer'
        />
        <!-- logo文字 -->
        <v-img alt="嘉旭福美" class="shrink mt-1 hidden-sm-and-down" contain width="100" height="40"
          src="../assets/images/logo_text.png"
          style='cursor:pointer'
        />
      </div>
      <!-- 导航项 -->
      <v-tabs right v-model="active_tab" :hide-slider="!sliderShow" v-if="pc">
        <v-tab v-for="tab of tabs" :key="tab.id" @click="goTo('#'+tab.name)" class="body_text">
          {{tab.label}}
        </v-tab>
        <v-tab disabled></v-tab>
      </v-tabs>
      <v-app-bar-nav-icon @click.stop="drawer = !drawer" v-else></v-app-bar-nav-icon>
      <v-navigation-drawer
        v-model="drawer"
        temporary
        absolute
        height='auto'
        overlay-color='rgba(1,1,1,0)'
        style="background-color:var(--secondary)"
      >
        <v-list
          nav
          dense
        >
          <v-list-item-group
            v-model="group"
            active-class="text--accent-4"
          >
            <v-list-item v-for="tab of tabs" :key="tab.id" @click="goTo('#'+tab.name)" class="body_text">
              <v-list-item-title>{{tab.label}}</v-list-item-title>
            </v-list-item>

          </v-list-item-group>
        </v-list>
      </v-navigation-drawer>
    </v-app-bar>
    <v-main>
      <!-- 头部视频占一屏 -->
      <!-- videoBox -->
      <div id="videoBox" class="videoBox">
        <video width="100%" id="video" class="video1 video" poster="../assets/images/video.jpg" autoplay loop  preload  muted  x-webkit-airplay="true" airplay="allow" webkit-playsinline="true" playsinline="true" x5-video-player-type="h5">
          <source src="../assets/images/3.mp4" type="video/mp4" />
        </video>
        <div class="videoShadow">
          <transition>
            <h1 class="first_title">
              <span class='line'></span>
              数据
              <span style="width:.5rem;height:.5rem;display:inline-block;background-color:white;margin-bottom:.5rem;border-radius:50%;"></span>
              <span> {{sloganList[slogan]}} </span>
              <span style="width:.5rem;height:.5rem;display:inline-block;background-color:white;margin-bottom:.5rem;border-radius:50%;"></span>
              未来
              <span class='line'></span>
            </h1>
          </transition>
        </div><!-- end of videoShadow" -->
      </div><!-- end of videoBox -->
      <!-- 关于我们 -->
      <div id="aboutUs" class="aboutUs">
        <div class="textBox">
          <div>
            <h1 class="second_title font-weight-thin mb-4">
              企业简介
            </h1>
            <h4 class="subheading body_text font-weight-thin mb-4">
              创立信息化领域的著名品牌，成为最优秀的大数据应用服务商
            </h4>
            <v-btn outlined color="primary" class="btn-blue" to="/about">了解更多</v-btn>
          </div>
        </div>
        <div class='imgBox'>
          <v-parallax src="../assets/images/about-us.jpg">
            <v-overlay absolute color="#3f51b520">
            </v-overlay>
          </v-parallax>
        </div>
      </div>
      <!-- 数据中心 -->
      <div id="dataCenter" class="dataCenter">
        <div class='imgBox'>
          <v-parallax src="../assets/images/products2.jpg">
            <v-overlay absolute color="#3f51b530">
            </v-overlay>
          </v-parallax>
        </div>
        <div class="textBox">
          <div>
            <h1 class="secon_title font-weight-thin mb-4 second_title">
              数据中心
            </h1>
            <h4 class="body_text font-weight-thin mb-4">
              可靠、安全、绿色
            </h4>
            <v-btn outlined color="primary" class="btn-blue" to='/dataCenter'>了解更多</v-btn>
          </div>
        </div>
      </div>
      <!-- 大数据平台 -->
      <div id='platform' class='platform'>
        <div  class='imgBox'>
          <v-carousel
            cycle
            hide-delimiter-background
            show-arrows-on-hover
            :height='imgheight'
          >
            <v-carousel-item
              v-for="i in platformList"
              :key="i.label"
            >
              <v-sheet :height='imgheight' color="white">
                <v-img :src="i.path" height='100%'></v-img>
                <v-overlay absolute color="#3f51b520" style="display:flex;flex-direction:column;align-items:start;justify-content:start">
                  <h1 class="second_title font-weight-thin mb-4 white--text">
                    大数据平台
                  </h1>
                  <p style="color:white;font-size: 1.5rem;text-indent:2em">
                    一 一 &nbsp;{{i.label}}
                  </p>
                  <h1 class="display-1 font-weight-thin mb-4">
                  </h1>
                  <p style="height:5rem;font-size: 1.5rem;text-indent:4em" ><v-btn outlined color="white" class="btn-dark" :to="i.to">了解更多</v-btn></p>
                  <!-- <v-btn outlined color="white" class="btn-dark" :to="i.to">了解更多</v-btn> -->
                </v-overlay>
              </v-sheet>
            </v-carousel-item>
          </v-carousel>
        </div>
      </div>
      <!-- 软件服务 -->
      <div id="products" class="products">
        <div class="textBox">
          <div>
            <h1 class="second_title font-weight-thin mb-4 white--text">
              软件服务
            </h1>
            <h4 class="body_text white--text">
              一站式软件服务提供商
            </h4>
            <h1 class="display-1 font-weight-thin mb-4">
            </h1>
            <v-btn outlined color="white" class="btn-dark" to="/products2">了解更多</v-btn>
          </div>
        </div>
        <div class='imgBox' >
          <div class="imgItem" data-content="智慧政务" @click="topartid('/products2','part2')">
            <img  src="../assets/images/products1.jpg">
          </div>
          <div class="imgItem" data-content="智慧教育" @click="topartid('/products2','part3')">
            <img  src="../assets/images/products2.jpg">
          </div>
          <div class="imgItem" data-content="企业办公" @click="topartid('/products2','part4')">
            <img src="../assets/images/products3.jpg">
          </div>
          <div class="imgItem" data-content="规划咨询" @click="topartid('/products2','part5')">
            <img src="../assets/images/products4.jpg">
          </div>
        </div>
      </div>
      <!-- 云产品 -->
      <div id="cloud" class="cloud">
        <div class='imgBox'>
          <v-parallax src="../assets/images/cloud.png">
            <v-overlay absolute color="#3f51b530">
            </v-overlay>
          </v-parallax>
        </div>
        <div class="textBox">
          <div>
            <h1 class="secon_title font-weight-thin mb-4 second_title">
              云服务
            </h1>
            <h4 class="body_text font-weight-thin mb-4">
              为客户上云减负增效
            </h4>
            <v-btn outlined color="primary" class="btn-blue" to='/products3'>了解更多</v-btn>
          </div>
        </div>
      </div>
      <!-- 媒体中心 -->
      <div id="media" class="media">
        <div class="mediaBox">
            <v-row align="center" justify="center">
              <v-col class="text-center" cols="12">
                <h1 class="second_title font-weight-thin mb-4">
                  新闻中心
                </h1>
                <h4 class="body_text subheading">
                  让价值共享 记录企业发展脚步
                </h4>
              </v-col>
            </v-row>
          <v-row align="center" justify="center">
            <v-hover v-slot="{ hover }">
              <v-carousel :cycle="!hover" hide-delimiters show-arrows-on-hover height="27rem">
                <v-carousel-item v-for="l in (newsList.length - news_items)" :key="l" >
                  <v-sheet color="backgroundColor" tile>
                    <div style="display:flex">
                      <v-hover v-for="n in news_items" :key='n'>
                        <v-card class="mx-auto" height="26rem"  width="360" color="white" elevation='8'>
                          <v-img
                          :src='newsList[l + n - 2].fmimg'
                          gradient="to top right, rgba(63, 81, 181,.1), rgba(63, 81, 181,.1)"
                          height="12rem"
                          >
                          </v-img>
                          <v-card-text>
                            <div class="news-text">
                              <div class="news-date">
                                <h2 class="primary--text text-center third_title" style="line-height:1.2">{{newsList[l + n -2].fbdate.date}}</h2>
                                <p>{{newsList[l + n -2].fbdate.year}}<br>{{newsList[l + n -2].fbdate.month}}</p>
                              </div>
                              <h2 class='body_text' v-text="newsList[l + n -2].xwbt"></h2>
                            </div>
                          </v-card-text>
                          <v-fade-transition>
                            <v-btn class="news-btn" :to="{path:'/newsDetails',query:{id:newsList[l + n -2].id}}" text plain color="fontColor">查看详情<v-icon>mdi-arrow-right</v-icon></v-btn>
                          </v-fade-transition>
                        </v-card>
                      </v-hover>
                    </div>
                  </v-sheet>
                </v-carousel-item>
              </v-carousel>
            </v-hover>
            <v-btn outlined color="primary" class="btn-blue" to="/news">了解更多</v-btn>
          </v-row>
        </div>
      </div>
      <!-- 联系我们 -->
      <div id="contact" class="contact">
        <v-col class="text-center" cols="12">
          <v-row>
            <v-col class="text-center" cols="12">
              <h1 class="second_title font-weight-thin mb-4 white--text">
                联系我们
              </h1>
              <h4 class="subheading body_text white--text"></h4>
            </v-col>
          </v-row>
          <div class='contactBox'>
            <div class="addressBox" >
              <v-card
                class="mx-auto"
                elevation="0"
                color="iconColor"
              >
                <v-list-item>
                  <v-list-item-content class="body_text white--text">电话：0312-6967888</v-list-item-content>
                </v-list-item>
                <v-list-item>
                  <v-list-item-content class="body_text white--text">传真：0312-6967888</v-list-item-content>
                </v-list-item>

                <v-list-item>
                  <v-list-item-content class="body_text white--text">邮箱：jxfm@hbjxfm.com</v-list-item-content>
                </v-list-item>

                <v-list-item>
                  <v-list-item-content class="body_text white--text">地址：河北省保定市定兴县福朔路166号</v-list-item-content>
                </v-list-item>
              </v-card>
              <v-btn outlined color="white" class="btn-dark" to='/contact'>了解更多</v-btn>
            </div>
            <Booking></Booking>
          </div>
        </v-col>
      </div>
      <!-- 悬浮图标-回到顶部 -->
      <v-fab-transition>
        <v-btn
          v-show="!floatHidden"
          color="primary"
          fixed
          bottom
          right
          fab
          @click="goTo('#videoBox')"
        >
          <v-icon>mdi-arrow-up</v-icon>
        </v-btn>
      </v-fab-transition>
    </v-main>
    <v-footer  color="secondary" style="height:auto">
      <FootContent :active="footList.active" :listWidth="footList.listWidth"></FootContent>
    </v-footer>
  </v-app>
  </div>
</template>

<script>
// @ is an alias to /src
import FootContent from '../components/footer.vue'
import Booking from '../components/booking.vue'
import wx from 'weixin-js-sdk'

export default {
  name: 'Home',
  components: {
    FootContent,
    Booking
  },
  data: () => ({
    // 是否为PC端
    pc: false,
    drawer: false,
    group: null,
    // 大图高度
    imgheight: '34rem',
    // 新闻轮播个数
    news_items: 3,
    slogan: 0,
    // 动画列表
    sloganList: ['承载', '驱动', '创造'],
    // 导航默认选项
    active_tab: 7,
    // 导航选项卡
    tabs: [
      { id: 1, name: 'aboutUs', label: '关于我们' },
      { id: 2, name: 'dataCenter', label: '数据中心' },
      { id: 3, name: 'platform', label: '大数据平台' },
      { id: 4, name: 'products', label: '软件服务' },
      { id: 5, name: 'cloud', label: '云服务' },
      { id: 6, name: 'media', label: '新闻中心' },
      { id: 7, name: 'contact', label: '联系我们' }
    ],
    tabsList: ['aboutUs', 'dataCenter', 'platform', 'products', 'cloud', 'media', 'contact'],
    scrollTopList: [],
    gotop: false,
    // 新闻列表
    newsList: [{
      fbdate: '2020-08-09',
      xwbt: '',
      id: 0

    }, {
      id: 1,
      fbdate: '2020-08-09',
      xwbt: ''
    }, {
      id: 2,
      fbdate: '2020-08-09',
      xwbt: ''
    }],
    // 导航背景颜色
    barColor: 'rgb(43, 64, 94,0)',
    // 导航阴影是否隐藏
    barFlat: true,
    // 导航栏是否隐藏
    barHide: false,
    // 悬浮按钮是否隐藏
    floatHidden: true,
    // 页脚参数
    footList: {
      listWidth: '10rem',
      active: [true, true, true]
    },
    // 导航滑块是否可见
    sliderShow: false,
    // 视频路径
    videoSrc: '../assets/images/2.mp4',
    // 大数据平台列表
    platformList: [{ path: require('../assets/images/platform_sjqx.png'), label: '数据清洗', to: '/products' }, { path: require('../assets/images/platform_sjck.jpg'), label: '数据仓库', to: '/products' }, { path: require('../assets/images/platform_sjfx.jpg'), label: '数据分析', to: '/products' }]
  }),
  created () {
    this.$nextTick(() => {
      this.getNews()
      this.toLocal()
      this.whatScreen()
    })
  },
  mounted () {
    wx.config({
      debug: false,
      appId: '111',
      timestamp: '111',
      nonceStr: '111',
      signature: '111',
      jsApiList: []
    })
    wx.ready(() => {
      const video = document.querySelectorAll('video')[0]
      video.play()
    })
    var that = this
    // 鼠标滚动事件监听
    window.addEventListener('scroll', this.handleScroll)
    this.tabsList.forEach((val, index, arry) => {
      this.scrollTopList.push(this.$el.querySelector('#' + val).offsetTop)
    })
    this.timer = setInterval(() => {
      if (this.slogan === 2) {
        this.slogan = 0
      } else { this.slogan = this.slogan + 1 }
    }, 3000)
    // 屏幕尺寸监听
    that.whatScreen()
    window.onresize = function () {
      that.whatScreen()
    }
  },
  watch: {
    active_tab (val, oldVal) {
      if (val === 7) {
        this.sliderShow = false
      } else {
        this.sliderShow = true
      }
    }
  },
  methods: {
    // 获取新闻信息
    async getNews () {
      const { data: res } = await this.$axios.post('erp/f/web/getXwInforList')
      const monthList = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec']
      this.newsList = res
      this.newsList.forEach((val, index, arry) => {
        // 日期转换为中文
        this.newsList[index].fbdate = {
          month: monthList[this.newsList[index].fbdate.split(' ')[0].split('-')[1] - 1],
          year: this.newsList[index].fbdate.split(' ')[0].split('-')[0],
          date: this.newsList[index].fbdate.split(' ')[0].split('-')[2]
        }
        this.newsList[index].fmimg = this.baseUrl + 'erp/' + res[index].fmimg.split('/erp/')[1]
      })
      // /wtpwebapps/
    },
    // 屏幕
    whatScreen () {
      var width = document.querySelector('html').offsetWidth
      if (width <= 768) {
        // title.innerHTML = "极小屏幕-" + width
        this.footList.active = [false, false, false]
        this.footList.listWidth = '90rem'
        this.news_items = 1
        this.barCollapse = true
        this.imgheight = '20rem'
        this.pc = false
      } else {
        if (width > 768 && width <= 992) {
          // title.innerHTML = "小屏幕-" + width
          this.footList.active = [true, true, true]
          this.footList.listWidth = '10rem'
          this.news_items = 2
          this.barCollapse = false
          this.imgheight = '28rem'
          this.pc = false
        } else {
          if (width > 992 && width <= 1100) {
            // title.innerHTML = "普通屏幕-" + width
            this.footList.active = [true, true, true]
            this.footList.listWidth = '10rem'
            this.news_items = 2
            this.barCollapse = false
            this.imgheight = '28rem'
            this.pc = true
          } else {
            if (width > 1200 && width <= 1600) {
              // title.innerHTML = "大屏幕-" + width
              this.footList.active = [true, true, true]
              this.footList.listWidth = '10rem'
              this.news_items = 3
              this.barCollapse = false
              this.imgheight = '32rem'
              this.pc = true
            } else {
              if (width > 1600) {
                // title.innerHTML = "大屏幕-" + width
                this.footList.listWidth = '10rem'
                this.footList.active = [true, true, true]
                this.news_items = 3
                this.barCollapse = false
                this.imgheight = '40rem'
                this.pc = true
              }
            }
          }
        }
      }
    },
    toLocal () {
      // 查找存储的锚点id
      const Id = localStorage.getItem('toId')
      const toElement = document.getElementById(Id)
      // 锚点存在跳转
      if (Id) {
        toElement.scrollIntoView()
      }
    },
    //  鼠标滚动事件（导航栏是否透明、导航栏是否隐藏投影、导航选项卡切换，悬浮按钮是否出现）
    handleScroll () {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop
      if (scrollTop > 50) {
        this.barFlat = false
        this.barColor = 'rgb(43, 64, 94,1)'
        this.gotop = true
      } else {
        this.barFlat = true
        this.barColor = 'rgb(43, 64, 94,0)'
        this.gotop = false
      }
      if (scrollTop >= this.scrollTopList[6]) {
        this.active_tab = 6
        this.floatHidden = false
      } else if (scrollTop >= this.scrollTopList[5] & scrollTop < this.scrollTopList[6]) {
        this.active_tab = 5
        this.floatHidden = false
      } else if (scrollTop >= this.scrollTopList[4] & scrollTop < this.scrollTopList[5]) {
        this.active_tab = 4
        this.floatHidden = false
      } else if (scrollTop >= this.scrollTopList[3] & scrollTop < this.scrollTopList[4]) {
        this.active_tab = 3
        this.floatHidden = false
      } else if (scrollTop >= this.scrollTopList[2] & scrollTop < this.scrollTopList[3]) {
        this.active_tab = 2
        this.floatHidden = false
      } else if (scrollTop >= this.scrollTopList[1] & scrollTop < this.scrollTopList[2]) {
        this.active_tab = 1
        this.floatHidden = false
      } else if (scrollTop >= this.scrollTopList[0] & scrollTop < this.scrollTopList[1]) {
        this.active_tab = 0
        this.floatHidden = false
      } else {
        this.active_tab = 7
        this.floatHidden = true
      }
    },

    // 软件服务页跳转定位
    topartid (path_, id) {
      const path = path_
      const Id = id
      localStorage.setItem('toPart', Id)
      this.$router.push(path)
    },
    goTo (ele) {
      // console.log(this.secondTabs, ele)
      // var anchor = this.$el.querySelector(ele)
      // document.documentElement.scrollTop = anchor.offsetTop + 500
      document.body.scrollTop = document.documentElement.querySelector(ele).offsetTop + 100
      document.documentElement.scrollTop = document.documentElement.querySelector(ele).offsetTop + 100
    }
  },
  // 将存储的锚点置空，否则会影响其他页面跳转到当前页面
  destroyed () {
    localStorage.setItem('toId', '')
    clearInterval(this.timer)
  }
}
</script>
